

<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">
  <form [formGroup]="filterGroup" ngProjectAs="filters">

    <mat-form-field appearance="outline">
      <mat-label>Metric</mat-label>
      <mat-select placeholder="Metric" formControlName="metric">
        @for (metric of metrics; track metric) {
          <mat-option [value]="metric">{{metric.displayName}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Aggregate</mat-label>
      <mat-select placeholder="Aggregate" formControlName="aggregation">
        <mat-option value="min">Min</mat-option>
        <mat-option value="max">Max</mat-option>
        <mat-option value="avg">Avg</mat-option>
        <mat-option value="sum">Total</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox formControlName="includeNtlData">Include Night Time Lights Data</mat-checkbox>

  </form>

  <div class="legend">
    <div #legendBar class="legend-bar"></div>
    <div class="legend-container">
      <div class="legend-labels">
        <span>{{ legendMin | number }}</span>
          <small>normal distribution</small>
        <span>{{ legendMax | number }}</span>
      </div>
      @if (filterGroup.get('metric')?.value) {
        <div class="measurement">{{ getLegendMeasurement() | titlecase}}</div>
      }
    </div>


    <div class="legend-extras">
      <div class="no-data">
        <div class="legend-box"></div>
        <span>No Data</span>
      </div>

      <div class="ntl-data">
        <div class="legend-box"></div>
        <span>NTL</span>
      </div>
    </div>

  </div>
</tgrid-layer-header>
